import React, { useEffect, useState } from 'react';
import { useInitializeLeadForm } from '../use-initialize-lead-form';
import { FormInfo } from 'src/types';
import { LeadGenericoForm, LeadsFormsProps } from '../LeadGenericoForm';
import {
  CanalDeContacto,
  CarlineSelect,
  ContactInfoWrapper,
  PantallaNombreApellido,
  Email,
  Telefono,
} from 'src/components';
import { OneElementTemplate, OneElementTemplateFullScreen } from 'src/feature-app/Screen';
import { MapaLeads } from 'src/forms/Leads';
import { Steps } from 'src/types';
import { ConfirmacionLeads } from '../ConfirmacionLeads';
import { Text } from '@volkswagen-onehub/components-core';
import { leadsCitaVentaData, leadsCitaVentaDealerData } from '.';
import { MapaLeadsInPage, partialDataCitaConfigurador, ConfirmacionLeadInPage } from 'src/forms/LeadsInPage';


const getMapaFields = (inPage: boolean) => {
  if (inPage === true) {
    return <MapaLeadsInPage formName="venta" showHorario={true} />;
  } else {
    return <MapaLeads formName="venta" showHorario={true} />;
  }
};

enum CitaVentaSteps {
  Mapa,
  Modelo,
  NombreApellido,
  Contacto,
  EmailTelefono,
  Confirmacion,
}


export function CitaVentaForm({ configRef, inPage, isConfigurador, isLeadDealer }: LeadsFormsProps) {
  const [partialData, setPartialData] = useState(null);

  useEffect(() => {
    if (isLeadDealer) {
      setPartialData(leadsCitaVentaDealerData);
    } else {
      setPartialData(leadsCitaVentaData);
    }
  }, []);

  const citaVentaSteps: Steps[] = [
    isLeadDealer ? null :
      {
        screenIndex: CitaVentaSteps.Mapa,
        name: 'Mapa',
        multiStep: true,
        component: getMapaFields(inPage),
      },
    {
      title: (
        <>
          <Text bold>¿{isLeadDealer ? "Qué " : "Y qué "}modelo </Text> te interesa?
        </>
      ),
      fields: (
        <>
          {inPage ?
            <OneElementTemplateFullScreen element={<div style={{ marginBottom: '2px' }}><CarlineSelect useCarline={true} /></div>} />
            :
            <OneElementTemplate element={<div style={{ marginBottom: '2px' }}><CarlineSelect useCarline={true} /></div>} />
          }
        </>
      ),
      screenIndex: CitaVentaSteps.Modelo,
      name: 'Modelo',
      outputs: ['modelo'],
      outputsText: ['modelo'],
    },
    {
      title: (
        <>
          Para poder preparar tu visita, necesitamos saber <Text bold>quién eres</Text>
        </>
      ),
      fields: (
        <>
          {inPage ?
            <OneElementTemplateFullScreen element={<div style={{ marginBottom: '2px' }}><PantallaNombreApellido /></div>} />
            :
            <OneElementTemplate element={<div style={{ marginBottom: '2px' }}><PantallaNombreApellido /></div>} />
          }
        </>
      ),
      screenIndex: CitaVentaSteps.NombreApellido,
      name: 'NombreApellido',
      outputs: ['name', 'surname', 'secondSurname'],
      outputsText: ['name', 'surname', 'secondSurname'],
    },
    {
      title: (
        <>
          <Text bold>¿Cómo prefieres </Text>que contactemos contigo?
          <sup style={{ top: 'auto', fontSize: '100%' }}>*</sup>
        </>
      ),
      fields: (
        <>
          {inPage ?
            <OneElementTemplateFullScreen element={<CanalDeContacto />} />
            :
            <OneElementTemplate element={<CanalDeContacto />} />
          }
        </>
      ),
      screenIndex: CitaVentaSteps.Contacto,
      name: 'Contacto',
      outputs: ['contacto'],
      outputsText: ['contacto'],
    },
    {
      title: (
        <>
          Para ello necesitaremos <Text bold>tus datos de contacto</Text>
        </>
      ),
      fields: (
        <>
          {inPage ?
            <OneElementTemplateFullScreen
              element={
                <ContactInfoWrapper>
                  <Telefono paginaConfirmacion={false} required={true} />
                  <Email paginaConfirmacion={false} required={true} paddingTop='24px' />
                </ContactInfoWrapper>
              }
            />
            :
            <OneElementTemplate
              element={
                <ContactInfoWrapper>
                  <Telefono paginaConfirmacion={false} required={true} />
                  <Email paginaConfirmacion={false} required={true} paddingTop='24px' />
                </ContactInfoWrapper>
              }
            />
          }
        </>
      ),
      screenIndex: CitaVentaSteps.EmailTelefono,
      name: 'EmailTelefono',
      outputs: ['cellphone', 'email'],
      outputsText: ['cellphone', '/', 'email'],
    },
    {
      fields: (
        <>
          {
            inPage ? <ConfirmacionLeadInPage /> : <ConfirmacionLeads />
          }
        </>
      ),
      screenIndex: CitaVentaSteps.Confirmacion,
      name: 'Confirmacion',
      isLastStep: true,
      hidePreviousStep: true,
    },
  ];
  const filteredSteps = citaVentaSteps.filter((step) => step !== null);
  const { loading, steps, firstStep, lastStep } = useInitializeLeadForm(filteredSteps, false, configRef, isConfigurador);

  const citaVentaInfo: Partial<FormInfo> = {
    numberOfScreens: steps.length,
  };

  return loading ? null : (
    <LeadGenericoForm
      steps={steps}
      leadData={isConfigurador ? partialDataCitaConfigurador : partialData}
      leadInfo={citaVentaInfo}
      firstStep={firstStep}
      lastStep={lastStep}
      inPage={inPage}
      isConfigurador={isConfigurador}
    />
  );
}
